<template>
  <div
    :class="['chatBox', isDark ? 'darkChatBox' : '']"
    id="apply"
    :style="{ height: heroHeight }"
  >
    <div class="chatHeader">
      <div class="headerUser">
        <div class="userAvatar">
          <img
            :src="
              aiAssistant.avatarFileUrl || aiAssistant.assistantAvatarFileUrl
            "
            alt=""
          />
        </div>
        <div class="userInfo">
          <h5>{{ this.aiAssistant.name || this.aiAssistant.assistantName }}</h5>
          <span>{{ this.aiAssistant.describe }}</span>
        </div>
      </div>
      <div class="headerAction">
        <el-button class="headerBtn" @click="goBack">
          <i class="ti-arrow-left"></i>
        </el-button>
      </div>
    </div>
    <div class="chatBody" ref="messagesRef">
      <!-- <button @click="logOut">退出登录</button> -->
      <div class="messages">
        <div
          :class="{
            messageItem: true,
            outgoingMsg: item.mine,
            darkMsgItem: isDark && !item.mine,
          }"
          v-for="(item, index) in talkList"
          :key="index"
        >
          <!-- <div 
          :class="['messageItem', item.mine ? 'outgoingMsg' : '']" 
          v-for="(item, index) in talkList" 
          :key="index"
        > -->
          <div class="messageUser">
            <div class="avatar">
              <div
                class="avatarImg"
                :style="'background-image: url(\'' + item.img + '\');'"
              ></div>
              <!-- <el-avatar :size="40" :src="item.img" class="avatarImg"></el-avatar> -->
            </div>
            <div class="info">
              <h5>{{ item.name }}</h5>
              <div class="time">{{ item.date }}</div>
            </div>
          </div>
          <div class="messageWrap">
            <div v-if="item.isimg">
              <img
                :src="item.rawText"
                alt=""
                class="messageImg"
                @click="showBigImg(item.rawText)"
                @load="setScroll"
              />
            </div>
            <div v-else @click="regEvent(item)">
              <!-- <div v-html="item.textContent"></div> -->
              <div
                :class="{ msgText: item.mine }"
                v-html="item.textContent"
              ></div>
            </div>
          </div>
          <!-- 复制/收藏 -->
          <div class="tools" v-if="!item.mine && !item.isimg">
            <el-tooltip effect="dark" content="复制" placement="bottom">
              <div class="icon" @click="copyText(item)">
                <i class="ti-layers"></i>
              </div>
            </el-tooltip>
            <el-tooltip effect="dark" content="收藏" placement="bottom">
              <div class="icon" @click="collectMsg(item)">
                <i class="ti-heart"></i>
              </div>
            </el-tooltip>
          </div>
          <!-- 图片下载 -->
          <!-- <div class="tools" v-if="!item.mine && item.isimg">
            <el-tooltip effect="dark" content="下载图片" placement="bottom">
              <div class="icon" @click="download(item)">
                <i class="ti-import"></i>
              </div>
            </el-tooltip>
          </div> -->
        </div>
      </div>
    </div>
    <div class="chatFooter">
      <div class="toolsBox">
        <!-- <div v-html="ceshiText"></div>
        <button @click="ceshi">测试</button> -->
        <el-tooltip
          v-if="aiAssistant.messageScene === 2"
          effect="dark"
          content="上传图片"
          placement="top"
        >
          <el-upload
            class="toolBtn"
            :action="uploadImgZipUrl"
            :show-file-list="false"
            :multiple="false"
            :limit="1"
            accept="image/jpg,image/png,image/jpeg"
            :on-success="uploadImgSuc"
          >
            <!-- <el-button type="text" class="toolBtn"> -->
            <i class="ti-image"></i>
            <!-- </el-button> -->
          </el-upload>
        </el-tooltip>
        <!-- <el-button type="text" class="toolBtn">
          <i class="ti-image"></i>
        </el-button> -->
        <el-tooltip effect="dark" content="下载会话" placement="top">
          <el-button type="text" class="toolBtn" @click="toExport">
            <i class="ti-import"></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="清屏功能" placement="top">
          <el-button type="text" class="toolBtn" @click="clearList">
            <i class="ti-trash"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div class="sendBox">
        <!-- <el-input
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3}"
          placeholder="请输入内容"
          v-model="inputMsg"
          class="sendInput" 
        >
        </el-input> -->
        <input
          v-model="inputMsg"
          type="text"
          class="sendInput"
          placeholder="Message Alice Maghyn.."
          :disabled="!aiAssistantId"
          @keyup.enter="SendMessage"
        />
        <el-button
          type="primary"
          class="sendBtn"
          :loading="send_loading"
          @click="SendMessage"
        >
          <img
            src="@/assets/chatImg/send.png"
            alt=""
            class="sendIcon"
            v-if="!send_loading"
          />
        </el-button>
      </div>
    </div>
    <!-- 底部安全区 -->
    <van-number-keyboard safe-area-inset-bottom />
    <!-- 展示大图 -->
    <el-dialog title="" :visible.sync="dialogTableVisible">
      <img :src="bigImgSrc" alt="" class="bigImg" />
    </el-dialog>
  </div>
</template>

<script>
import * as signalR from '@microsoft/signalr'
import MarkdownIt from 'markdown-it'
import api from '@/api'
import config from '@/config'
import { Marked } from 'marked'
import { markedHighlight } from 'marked-highlight'
import hljs from 'highlight.js'
import utils from '@/utils/utils'
import { enumMessageCode, enumCallType } from '@/store/enum'
import { mapActions, mapState, mapMutations } from 'vuex'

const marked = new Marked(
  markedHighlight({
    langPrefix: 'hljs language-',
    highlight(code, lang, info) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext'
      return hljs.highlight(code, { language }).value
    },
  })
)

const md = new MarkdownIt()

export default {
  name: 'NewChat',
  components: {},
  props: [],
  data() {
    return {
      ChatCompletionFull: api.ChatCompletionFull,
      ChatCreateImage: api.ChatCreateImage,
      collect: api.collect,
      GetWXAuthUrl: api.GetWXAuthUrl,
      GetChatHistory: api.GetChatHistory,
      GetOpenAIAccount: api.GetOpenAIAccount,
      SyncChatHistory: api.SyncChatHistory,
      Export: api.Export,
      wsServerUrl: config.BASE_URL_WS,
      apiServerUrl: config.BASE_URL,
      //文生图处理中
      textToImg_Loading: false,
      //打开文生图
      dialogTextToImgVisible: false,
      isShowHint: true,
      talkList: [],
      messageText: '',
      inputMsg: '',
      uploadimgsrc: '',
      inputMaxLength: 1500, //最大输入
      defaultImgUrl: require('../../../assets/img/default_avatar.png'),
      send_loading: false,
      //上传图片开关
      imgffo: false,
      uploadimgsrc: '', //上传图片地址
      // gptImg: require('../../../assets/img/logo.png'),
      // isAuth: false,
      callType: enumCallType.WebSocket,
      dialogTableVisible: false, // 展示大图
      bigImgSrc: '', // 大图地址
      //连接
      reconnectMS: 2000,
      connection: null,
      openAIAccount: {},
      uploadImgZipUrl:
        process.env.VUE_APP_BASE_URL + '/api/sysFileInfo/uploadImgZip',
      // 安全区开关
      isShowEmpty: false,
      // ceshiText: '```123```\n',
      // 显示区域高度
      heroHeight: '100vh',
    }
  },
  computed: {
    ...mapState('userAbout', [
      'user',
      'aiAssistantId',
      'autoLogin',
      'aiAssistant',
      'sessionKey',
      'isAuth',
    ]),
    ...mapState('comAbout', ['isDark']),
  },
  watch: {
    // taleList: {
    //   handler(val, preVal) {
    //     const newTalk = val.map(item => {
    //       const conversationId = item.conversationId;
    //       const toolEl = `<div class="talktool"><div class="talktool-warp"><span onclick="regEvent(\'copy\',${conversationId})"><span class="copy-btn">复制</span><i class="el-icon-copy-document copy-btn" circle></i></span><span class="btn-margin"></span><span onclick="regEvent(\'collect\',${conversationId})"><span class="collect-btn">收藏</span><i class="el-icon-star-off collect-btn" circle></i></span></div></div>`;
    //       const textContent = item.text.text.replace(toolEl, '');
    //       return { ...item, textContent };
    //     })
    //     this.talkList = newTalk;
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // 监听AI助手等id
    aiAssistantId: {
      handler(val, preVal) {
        // console.log(val);
        if (val) {
          this.getHistory()
        } else {
          this.talkList = []
        }
      },
      immediate: true,
    },
    // 自动滚动到底部
    talkList: {
      handler(val, prev) {
        if (val?.length) {
          this.setScroll()
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    // 重新调整页面高度
    this.handleResize()
    //注册window事件
    window.regEvent = this.regEvent
    // this.loginOkThen();
  },
  methods: {
    ...mapActions('userAbout', ['getCollectList']),
    ...mapMutations('userAbout', ['changeIsAuth']),
    ...mapMutations('comAbout', ['changeIsShowHint']),
    // 切换安全区
    // handleEmptyBox(){
    //   if (config.isMobile) {
    //     this.isShowEmpty = !this.isShowEmpty;
    //   }
    // },
    // ceshi(){
    //   console.log(marked.parse('```1230```hhh'));
    //   this.ceshiText = marked.parse(this.ceshiText + '1. hh');
    // },
    // 重新调整页面高度--IOS调整高度
    handleResize() {
      console.log('高度', window.innerHeight)
      // 调整页面高度
      if (
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i)
      ) {
        //判断设备类型
        this.heroHeight = `${window.innerHeight}px`
      } else {
        this.heroHeight = '100vh'
      }
    },
    // 下载图片
    download(item) {
      console.log(item)
      // 测试下载图片
      // const xhr = new XMLHttpRequest();
      // xhr.responseType = 'blob';
      // xhr.onload = function() {
      //   const a = document.createElement('a');
      //   a.href = window.URL.createObjectURL(xhr.response);
      //   a.download = 'image.jpg';
      //   a.click();
      // }
      // xhr.open('GET', item.rawText);
      // xhr.send();
      const a = document.createElement('a')
      fetch(item.rawText)
        .then((res) => res.blob())
        .then((blob) => {
          a.href = URL.createObjectURL(blob)
          console.log(a.href)
          a.download = 'image.png'
          document.body.appendChild(a)
          a.click()
        })
      // utils.downloadByBlob(item.rawText, 'image.png');
    },
    // 查看大图
    showBigImg(src) {
      this.bigImgSrc = src
      this.dialogTableVisible = true
    },
    // 调整滚动条
    setScroll() {
      // 调整滚动条到最底部
      this.$nextTick(() => {
        const messageElem = this.$refs.messagesRef
        messageElem.scrollTop = messageElem.scrollHeight
      })
    },
    // 获取历史数据
    getHistory() {
      // 获取对话记录
      this.GetChatHistory({ aiAssistantId: this.aiAssistantId })
        .then((res) => {
          if (res.success) {
            try {
              const chatHistory = res.data.chatHistory
              if (chatHistory) {
                const list = JSON.parse(chatHistory)
                // console.log("list", list);
                // var lastFromServer = list[list.length - 1]
                // var lastFromLocal = this.talkList[this.talkList.length - 1]
                // if (lastFromServer) {
                //   if (
                //     !lastFromLocal ||
                //     lastFromServer.date > lastFromLocal.date
                //   ) {
                //比较时间
                this.talkList = JSON.parse(chatHistory).map((item) => {
                  // const conversationId = item.conversationId;
                  // const toolEl = `<div class="talktool"><div class="talktool-warp"><span onclick="regEvent(\'copy\',${conversationId})"><span class="copy-btn">复制</span><i class="el-icon-copy-document copy-btn" circle></i></span><span class="btn-margin"></span><span onclick="regEvent(\'collect\',${conversationId})"><span class="collect-btn">收藏</span><i class="el-icon-star-off collect-btn" circle></i></span></div></div>`;
                  // const textContent = item.text.text.replace(toolEl, "");
                  let textContent = marked.parse(item.rawText)
                  // console.log('历史记录', textContent);
                  textContent = this.formatMsg(textContent)
                  // if (textContent.theme !== 'light') {
                  //   textContent = item.text.text.replace(toolEl, "");
                  // } else {
                  //   textContent = item.rawText;
                  // }
                  return { ...item, textContent }
                })
                // console.log('聊天记录', this.talkList);
                // 调整滚动条到最底部
                // this.setScroll();

                // this.$nextTick(() => {
                //   const messageElem = this.$refs.messagesRef;
                //   messageElem.scrollTop = messageElem.scrollHeight;
                // })
                // this.taleList = JSON.parse(chatHistory)
                // }
                // }
              } else {
                this.talkList = []
              }
            } catch (error) {
              // alert(error.message);
            }
          }
          // this.loading = false
        })
        .catch((e) => {
          // this.loading = false
        })
    },
    // 收藏
    collectMsg(item) {
      this.collect({
        ConversationId: item.conversationId,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: `已收藏`,
              type: 'success',
            })
            this.getCollectList('')
          } else {
            this.$message.error('收藏失败：' + res.message)
          }
          // this.loading = false;
        })
        .catch((e) => {
          // this.loading = false;
        })
    },
    // 复制
    copyText(item) {
      utils.copyByItem(this.talkList, this, item.conversationId)
    },
    // 点击对话框事件
    regEvent(item) {
      // console.log('点击对话框', item);
      if (item.mine) {
        // const element = document.getElementById(param);
        // const text = element && element.innerText;
        // console.log(item.rawText);
        this.inputMsg = item.rawText || ''
      }
    },
    // regEvent(eventType, param) {
    //   if (eventType === "mine") {
    //     const element = document.getElementById(param);
    //     const text = element && element.innerText;
    //     console.log(text);
    //     this.inputMsg = text || "";
    //   }
    // },
    //设置响应
    loginOkThen(res) {
      // alert('授权');
      // alert(utils.isWechat());
      // alert(!this.$route.params.fromAuth);
      // console.log(123, this.user);
      localStorage.setItem(this.sessionKey, this.user.session)
      // this.isAuth = true
      this.changeIsAuth(true)

      //判断授权
      let flag =
        !this.$route.params.fromAuth && //不是来自授权
        utils.isWechat() && //是微信浏览器
        !this.autoLogin //不是自动登录
      // !this.user.openId // openId不存在

      // if (flag) {
      if (flag && process.env.NODE_ENV == 'production') {
        // console.log(456);
        //跳转到微信微信授权
        // this.loading = true
        this.GetWXAuthUrl({ userId: this.user.id })
          .then((res) => {
            if (res.success) {
              window.location.href = res.data
            }
            // this.loading = false
          })
          .catch((e) => {
            // this.loading = false
          })
      } else {
        // console.log(789);
        //授权完后或不需要授权加载
        if (this.callType == enumCallType.WebSocket) {
          //初始化连接
          this.initSignalRConnection()
        }
        // 判断用户是否第一次登录
        const userList = JSON.parse(localStorage.getItem('userList')) || []
        const isFirst = userList.includes(this.user.phone)
        // 移动端展示引导页，非微信浏览器
        if (!isFirst && config.isMobile && utils.isWechat()) {
          this.changeIsShowHint(true)
          const newUserList = userList.concat(this.user.phone)
          localStorage.setItem('userList', JSON.stringify(newUserList))
        }

        // 从服务器获取
        // this.toGetChatHistory() // 3
        // 获取账户配置
        this.toGetOpenAIAccount() // 4
      }

      //版本更新
      //this.showEdition();
    },
    //初始化连接
    async initSignalRConnection() {
      //创建连接
      this.createConnection(false)

      //设置重连
      var that = this
      setTimeout(async () => {
        await that.connect()
      }, 500)
    },
    //创建链接
    createConnection(useApiServer) {
      var chatServerUrl = this.wsServerUrl
      if (useApiServer) {
        chatServerUrl = this.apiServerUrl
      }
      console.log('连接:' + chatServerUrl)
      try {
        this.connection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.None)
          .withUrl(
            `${chatServerUrl}/hubs/chathub?session=${this.user.session}`,
            {
              transport:
                signalR.HttpTransportType.WebSockets |
                signalR.HttpTransportType.LongPolling,
            }
          )
          //.withTimeout(5000) // 设置超时时间为5秒
          .withAutomaticReconnect([0, this.reconnectMS, 0])
          .build()
        //重新开始连接时
        this.connecting = false
      } catch (error) {
        this.$message.error('初始化连接错误')
        console.log('连接错误-build：' + error.toString())
      }

      var that = this
      //注册事件
      var closeCount = 3
      //断开
      this.connection.onclose(async (event) => {
        if (--closeCount > 0) {
          console.log('连接断开')
          that.$message('连接断开')
          setTimeout(async () => {
            await that.connect()
          }, this.reconnectMS)
        } else {
          that.closeAllShowingMsg()
          that.$message({
            message: '连接不稳定，请重新登录。',
            type: 'warning',
            duration: 0, //不关闭
          })
          that.$message.info('连接不稳定，即将跳转到登录页...')
          setTimeout(() => {
            // that.$refs.infoDrawerRef.logout()
            this.logOut()
            // localStorage.removeItem(this.sessionKey);
            // // this.isAuth = false;
            // this.changeIsAuth(false);
            // that.closeAllShowingMsg();
            // this.$router.push('/login');
          }, 2000)
        }
      })
      //重连
      this.connection.onreconnected(() => {
        console.log('已重连')
        that.$message({
          message: '已重连',
          type: 'success',
          duration: 1000,
        })
        that.closeAllShowingMsg()
      })
      //重连中
      this.connection.onreconnecting(() => {
        console.log('正在重连...')
        that.$message({
          message: '正在重连...',
          type: 'warning',
          duration: 0, //不关闭
        })
      })

      //消息接收方法
      this.connection.on('RM', (message, conversationId) => {
        // console.log("RM", message, conversationId);
        this.ReceiveMessage(message, conversationId)
      })
    },
    //连接到聊天服务器
    async connect() {
      var that = this
      if (that.connecting) {
        return
      }
      that.closeAllShowingMsg()
      that.connecting = true
      var isOk = false
      console.log('连接中...')
      try {
        await that.connection
          .start()
          .then(() => {
            isOk = true
            that.connecting = false
            console.log('连接成功！')
          })
          .catch((err) => {
            that.$message.error('连接到服务器错误')
            console.log('连接错误-start：' + err.toString())
            console.log('连接错误：' + that.connection.url)
          })
      } catch (error) {
        that.$message.error('未知错误')
        console.log('连接错误-code：' + error.toString())
      }
      if (isOk == false) {
        //debugger
        //连接失败则使用api的服务器
        that.createConnection(true)
        setTimeout(async () => {
          await that.connect()
        }, that.reconnectMS)
      }
      that.closeAllShowingMsg()
      that.connecting = false
    },
    //接收消息
    ReceiveMessage(pMessage, conversationId) {
      var message = null
      try {
        message = JSON.parse(pMessage)
      } catch (error) {
        //console.log(pMessage);
      }
      if (!message || !conversationId) {
        return
      }
      // console.log("接收", message);
      // this.received = true
      //还原消息字段
      message.text = message.t
      message.isEnd = Boolean(message.e)
      message.isSuccess = Boolean(message.s)
      message.code = message.c

      //查找已经存在的对话
      var tales = this.talkList.filter(
        (p) => p.conversationId == conversationId
      )
      //消息标识对话结束
      if (message.isEnd) {
        var tale = null
        if (tales.length) {
          tale = tales[0]
          var temp_text = tale.text.text
          // console.log(temp_text)
          //处理html标签
          // temp_text = this.replaceHTMLTagsWithShortcode(temp_text);
          //处理md样式
          // temp_text = this.renderMD(temp_text);

          //处理md样式 marked
          // temp_text = marked.parse(temp_text, { pedantic: true })
          temp_text = marked.parse(temp_text)
          temp_text = this.formatMsg(temp_text)
          tale.text.text = temp_text
          tale.textContent = temp_text

          //加入复制收藏按钮
          // this.buildToolEl(tale, conversationId)

          //同步记录
          this.toSyncChatHistory()
          this.send_loading = false
        }

        //debugger
        //处理返回代码
        switch (message.code) {
          case enumMessageCode.余额不足:
            //弹出充值弹窗
            this.$message.warning(message.text)
            // this.$refs.infoDrawerRef.addNumber()
            break
          case enumMessageCode.用户会话无效:
            this.$message.info('登录已失效，即将跳转到登录页...')
            setTimeout(() => {
              // this.$refs.infoDrawerRef.logout()
              this.logOut()
              // localStorage.removeItem(this.sessionKey);
              // this.changeIsAuth(false);
              // that.closeAllShowingMsg();
              // this.$router.push('/login');
            }, 2000)
            break
          case enumMessageCode.弹出:
            this.$message.warning(message.text)
            break
          case enumMessageCode.函数生成:
            tale && (tale.isByFun = true)
            break
          case enumMessageCode.答复超长:
            this.SendMessageMain(tale.rawText, true)
            break
        }
        if (message.code) {
          this.send_loading = false
        }
      }
      //渲染到对话块
      // console.log("渲染到对话框", message);
      var text = message.text || ''
      if (text) {
        if (tales.length) {
          var tale = tales[0]
          try {
            tale.text.text += text
            tale.rawText += text
            tale.textContent += text
          } catch (error) {
            //debugger;
          }
        } else {
          const msgObj = {
            date: utils.getNowDate(),
            text: { text: text },
            rawText: text,
            isimg: false,
            mine: false,
            // name: '捷捷',
            name: this.aiAssistant.textTitle,
            // img: this.gptImg,
            img: this.aiAssistant.avatar,
            conversationId: conversationId,
            role: 'assistant',
            isSucc: message.isSuccess,
            textContent: text,
            // isSucc: message.isSuccess == 1 ? true : false,
          }
          this.talkList.push(msgObj)
          // this.setScroll();
        }
      }
    },
    //同步对话记录
    toSyncChatHistory() {
      //debugger;
      // this.loading = true
      // console.log(this.aiAssistantId);
      var param = {
        ChatHistory: JSON.stringify(this.talkList),
        aiAssistantId: this.aiAssistantId,
      }
      this.SyncChatHistory(param)
        .then((res) => {
          if (res.success) {
            //console.log("同步成功");
            var tip_max = 100
            var del_max = 110
            var residue = 10
            if (this.talkList.length >= tip_max) {
              var text = `对话记录已达到${tip_max}，可能会造成卡顿，建议将需要的内容收藏或导出后清除聊天记录！超过${del_max}条后将自动清除至剩${residue}条最近的聊天记录。如果有相关的需求请联系客服或通过反馈告诉我们。`
              this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: this.isDark ? 'darkMessage' : '',
              })
                .then(() => {})
                .catch(() => {})
            }
            if (this.talkList.length > del_max) {
              //debugger;
              this.talkList = this.talkList.slice(-residue)
              this.SyncChatHistory({
                aiAssistantId: this.aiAssistantId,
              })
            }
          }
          // this.loading = false
        })
        .catch((e) => {
          // this.loading = false
        })
    },
    //关闭所有悬停的弹窗
    closeAllShowingMsg() {
      this.$message.closeAll()
    },
    //替换文本
    replaceHTMLTagsWithShortcode(text) {
      // 使用正则表达式匹配 HTML 标签
      var regex = /<([^>]+)>/g
      // 将匹配到的 HTML 标签替换为短代码格式
      var shortcode = '`<$1>`'
      var result = text.replace(regex, shortcode)
      // console.log(result);
      return result
    },
    hasMarkdownTableOrCode(text) {
      //debugger
      // 匹配 Markdown 表格的正则表达式
      const tableRegex = /^\s*\|.*\|\s*$/m
      // 匹配 Markdown 代码块的正则表达式
      const codeRegex = /^```.*\n[\s\S]*?\n```$/m
      // 匹配 Markdown 代码块的正则表达式
      const codeRegexSmall = /`([^`]+)`/g

      // 判断文本中是否包含表格或代码块
      return (
        tableRegex.test(text) ||
        codeRegex.test(text) ||
        codeRegexSmall.test(text)
      )
    },
    //渲染md样式
    renderMD(temp_text) {
      temp_text = this.replaceHTMLTagsWithShortcode(temp_text)
      //处理md样式
      if (this.hasMarkdownTableOrCode(temp_text)) {
        var rendered = md.render(temp_text)
        //console.log(rendered);
        rendered = this.removeTableTags(rendered)
        //console.log(rendered);
        temp_text = rendered
      }

      return temp_text
    },
    //去掉表格相关的标签
    removeTableTags(text) {
      // 去掉标签后面的换行符
      text = text.replace(/<table>\n/gi, '<table>')
      text = text.replace(/<\/table>\n/gi, '</table>')
      text = text.replace(/<thead>\n/gi, '<thead>')
      text = text.replace(/<\/thead>\n/gi, '</thead>')
      text = text.replace(/<th>\n/gi, '<th>')
      text = text.replace(/<\/th>\n/gi, '</th>')
      text = text.replace(/<tbody>\n/gi, '<tbody>')
      text = text.replace(/<\/tbody>\n/gi, '</tbody>')
      text = text.replace(/<td>\n/gi, '<td>')
      text = text.replace(/<\/td>\n/gi, '</td>')
      text = text.replace(/<tr>\n/gi, '<tr>')
      text = text.replace(/<\/tr>\n/gi, '</tr>')
      return text
    },
    //生成唯一id
    getUniqueId() {
      const uniqueId = Date.now() + Math.floor(Math.random() * 1000)
      return uniqueId
    },
    /** 处理显示内容格式
     * msgStr  marked转化后的html
     */
    formatMsg(htmlText) {
      // console.log("htmlText", htmlText);
      // return htmlText
      var tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlText
      // console.log("tempDiv", tempDiv);
      // 遍历tempDiv的所有子节点，并移除不在<pre>标签内的换行符
      var children = tempDiv.childNodes
      // console.log('--children', children)
      var output = ''
      for (var i = 0; i < children.length; i++) {
        var node = children[i]
        if (node.nodeType === 3) {
          if (node.nodeValue !== '\n') {
            output += node.nodeValue
          }
        } else if (node.tagName.toLowerCase() === 'pre') {
          output += node.outerHTML
        } else {
          output += node.outerHTML.replace(/\r?\n/g, '')
        }
      }

      // console.log('最后--', output)
      return output
    },
    /**
     * 发送消息
     * messageScene
     */
    SendMessageMain(msg, imgsrc, isContinueForLen, messageScene) {
      //1.TextToText;2.ImageToText;3.TextToImage;4.TextToSpeech;
      try {
        //验证登录
        if (!this.isAuth) {
          this.$message({
            message: '未认证！',
            type: 'warning',
          })
          return
        }
        if (!msg) return
        //验证长度
        //debugger
        this.inputMaxLength = this.openAIAccount.maxInput / 2
        if (msg.length > this.inputMaxLength) {
          this.$message({
            message: `输入字数不能超过${this.inputMaxLength}！`,
            type: 'warning',
          })
          return
        }
        //组织消息内容
        let temp_text = msg
        temp_text = this.replaceHTMLTagsWithShortcode(temp_text)
        //处理md样式
        if (this.hasMarkdownTableOrCode(temp_text)) {
          var rendered = md.render(temp_text)
          //console.log(rendered);
          rendered = this.removeTableTags(rendered)
          //console.log(rendered);
          temp_text = rendered
        }
        var elId = `msg${this.getUniqueId()}`
        var text = `<span class="pointer" onclick="regEvent(\'mine\',\'${elId}\')">${temp_text}</span>\
                    <span id="${elId}" style="display:none;">${msg}</span>`

        const msgObj = {
          date: utils.getNowDate(),
          text: { text: text },
          rawText: msg,
          isimg: false,
          mine: true,
          name: this.user.userName,
          img: this.user.avatarFileUrl || this.defaultImgUrl,
          conversationId: 0,
          role: 'user',
          isSucc: true,
          textContent: text,
        }

        let contexts = []
        //判断调用方式
        if (
          this.callType == enumCallType.WebSocket &&
          (messageScene === 1 || messageScene === 2)
        ) {
          //websokect发送     messageScene == 1 文生文 || messageScene == 2 图生文  ；

          let conitem = {}
          for (var i = this.talkList.length - 1; i >= 0; i--) {
            if (this.talkList[i].isSucc == true) {
              if (i + 1 < this.talkList.length) {
                if (this.talkList[i].role != this.talkList[i + 1].role) {
                  conitem = {
                    text:
                      this.talkList[i].rawText || this.talkList[i].text.text,
                    role: this.talkList[i].role,
                  }
                  contexts.push(conitem)
                }
                //continue;
              } else {
                conitem = {
                  text: this.talkList[i].rawText || this.talkList[i].text.text,
                  role: this.talkList[i].role,
                }
                contexts.push(conitem)
              }
            }
            if (contexts.length > 1) {
              break
            }
          }
          contexts.reverse()
          // console.log(this.connection);
          // console.log('组织上下文:' + JSON.stringify(contexts))

          // 判断连接状态
          if (this.connection.state != 'Connected') {
            this.$message({
              message: '正在连接到服务器...',
              type: 'warning',
            })
            setTimeout(() => {
              this.inputMsg = msg
            }, 100)
            return
          }
          console.log('>>>>>>>>>>>发送')
          console.log({
            session: this.user.session,
            message: msg,
            img: imgsrc,
            context: JSON.stringify(contexts),
            isContinueForLen: isContinueForLen,
            messageScene: messageScene,
          })
          //发送
          this.connection
            .invoke('SendMessage', {
              session: this.user.session,
              aiAssistantId: this.aiAssistantId,
              message: msg,
              img: imgsrc,
              context: JSON.stringify(contexts),
              isContinueForLen: isContinueForLen,
              messageScene: messageScene,
            })
            .catch((err) => {
              this.$message.error('发送失败：请重试！')
              this.inputMsg = msg
              console.log(err.toString())
              this.send_loading = false
              // this.received = true
            })

          this.send_loading = true
          // this.received = false
          this.imgffo = false
          this.uploadimgsrc = ''
          this.inputMsg = ''
        } else {
          //http调用
          this.send_loading = true
          // this.received = false

          if (messageScene == 1 || messageScene == 2) {
            console.log('>>>>>>>>>> messageScene=' + messageScene)

            this.ChatCompletionFull({
              session: this.user.session,
              aiAssistantId: this.aiAssistantId,
              message: msg,
              img: imgsrc,
              context: contexts,
              isContinueForLen: isContinueForLen,
            })
              .then((res) => {
                if (res.success) {
                  //清空图片，以后对话不再关联图片
                  this.uploadimgsrc = ''
                  var text = res.data.message

                  // text='# 标题1'
                  console.log('text')
                  console.log(text)
                  var render_text = marked.parse(text)
                  // const html = marked.parse('# Marked in Node.js\n\nRendered by **marked**.');

                  //处理html标签
                  //temp_text = this.replaceHTMLTagsWithShortcode(temp_text);
                  //处理md样式
                  //temp_text = this.renderMD(temp_text);

                  console.log('render_text')
                  console.log(render_text)
                  // render_text=render_text.replace('<br>','')
                  render_text = this.formatMsg(render_text)

                  //添加消息
                  const msgObj = {
                    date: utils.getNowDate(),
                    text: { text: '' },
                    rawText: text,
                    isimg: false,
                    mine: false,
                    name: this.aiAssistant.textTitle,
                    // name: '捷捷',
                    img: this.aiAssistant.avatar,
                    // img: this.gptImg,
                    conversationId: res.data.conversationId,
                    role: 'assistant',
                    isSucc: res.data.isSuccess == 1 ? true : false,
                    textContent: '',
                  }
                  this.talkList.push(msgObj)

                  if (res.data.isSuccess) {
                    //模拟打字机
                    var chars = render_text.split('')
                    var count = 0
                    var timer = setInterval(function () {
                      var len = 10
                      if (count < chars.length) {
                        var typing = chars.slice(count, count + len).join('')
                        msgObj.text.text += typing
                        msgObj.textContent += typing
                        count += len
                      } else {
                        clearInterval(timer)
                      }
                    }, 100)
                    //添加工具栏
                    // this.buildToolEl(msgObj, res.data.conversationId)
                  } else {
                    msgObj.text.text = render_text
                    msgObj.textContent = render_text
                  }
                } else {
                  this.$message.error('发送失败：请重试！')
                  this.inputMsg = msg
                  // console.log(res);
                }

                this.send_loading = false
                // this.received = true
              })
              .catch((err) => {
                //debugger;
                this.$message.error('发送失败：请重试！')
                this.inputMsg = msg
                // console.log(err.toString());
                this.send_loading = false
                // this.received = true
              })
          } else if (messageScene == 3) {
            //
            console.log('>>>>>>>>>>>  CrateImage ')
            this.textToImg_Loading = false
            this.dialogTextToImgVisible = false

            var loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            })
            console.log({
              session: this.user.session,
              message: msg,
              context: contexts,
              isContinueForLen: isContinueForLen,
            })
            this.ChatCreateImage({
              httpgpt: this.callType == enumCallType.WebSocket,
              session: this.user.session,
              message: msg,
              context: contexts,
              isContinueForLen: isContinueForLen,
            })
              .then((res) => {
                // console.log(res);
                this.textToImg_Loading = false
                this.dialogTextToImgVisible = false
                // loading.close();
                if (res.success) {
                  var data = res.data.imageCreateResponse
                  if (data.successful) {
                    var img0 = res.data.imageCreateResponse.results[0].url
                    // var img0='data:image/png;base64,'+res.data.imageCreateResponse.results[0].b64;
                    console.log(
                      '>>>>>>>>>> CreateImg img0 length=' + img0.length
                    )
                    var text = `<img data-src="${img0}" />`
                    const msgObj = {
                      date: utils.getNowDate(),
                      text: { text: text },
                      rawText: img0,
                      isimg: true,
                      mine: false,
                      name: this.aiAssistant.textTitle,
                      // name: '捷捷',
                      img: this.aiAssistant.avatar,
                      // img: this.gptImg,
                      conversationId: res.data.conversationId,
                      role: 'assistant',
                      isSucc: res.data.isSuccess == 1 ? true : false,
                      textContent: text,
                    }

                    this.talkList.push(msgObj)
                    this.inputMsg = ''
                    this.toSyncChatHistory()
                  } else {
                    //
                    this.$message.error('发送失败：' + data.error.message)
                  }
                } else {
                  this.$message.error('发送失败：请重试！')
                  this.inputMsg = msg
                  // console.log(res);
                }

                this.send_loading = false
                // this.received = true
                loading.close()
              })
              .catch((err) => {
                // loading.close();
                this.textToImg_Loading = false
                this.dialogTextToImgVisible = false
                // console.log(err);
                //debugger;
                this.$message.error('发送失败：请重试！')
                this.inputMsg = msg
                console.log(err.toString())
                this.send_loading = false
                // this.received = true
              })
          } else if (messageScene == 4) {
            //
            console.log('>>>>>>>>>>>  CrateSpeech ')
            this.textToSpeech_Loading = false
            this.dialogTextToSpeechVisible = false

            // var loading = this.$loading({
            //   lock: true,
            //   text: "Loading",
            //   spinner: "el-icon-loading",
            //   background: "rgba(0, 0, 0, 0.7)",
            // });
            console.log({
              session: this.user.session,
              message: msg,
              context: contexts,
              isContinueForLen: isContinueForLen,
            })
            this.ChatCreateSpeech({
              httpgpt: this.$props.callType == enumCallType.WebSocket,
              session: this.user.session,
              message: msg,
              context: contexts,
              isContinueForLen: isContinueForLen,
            })
              .then((res) => {
                // console.log(res);
                this.textToSpeech_Loading = false
                this.dialogTextToSpeechVisible = false
                // loading.close();
                if (res.success) {
                  var audioUrl = res.data.audioUrl
                  console.log(
                    '>>>>>>>>>> ChatCreateSpeech audioUrl = ' + audioUrl
                  )
                  var text = `<audio data-src="${audioUrl}" />`
                  const msgObj = {
                    date: utils.getNowDate(),
                    text: { text: text },
                    rawText: audioUrl,
                    isimg: false,
                    mine: false,
                    name: this.aiAssistant.textTitle,
                    // name: '捷捷',
                    img: this.aiAssistant.avatar,
                    // img: this.gptImg,
                    conversationId: res.data.conversationId,
                    role: 'assistant',
                    isSucc: res.data.isSuccess == 1 ? true : false,
                    textContent: text,
                  }

                  this.talkList.push(msgObj)
                } else {
                  this.$message.error('发送失败：请重试！')
                  this.inputMsg = msg
                  // console.log(res);
                }

                this.send_loading = false
                // this.received = true
              })
              .catch((err) => {
                // loading.close();
                this.textToImg_Loading = false
                this.dialogTextToImgVisible = false
                // console.log(err);
                //debugger;
                this.$message.error('发送失败：请重试！')
                this.inputMsg = msg
                console.log(err.toString())
                this.send_loading = false
                // this.received = true
              })
          }
        }

        //添加到消息列表
        !isContinueForLen && this.talkList.push(msgObj)
        // this.setScroll();
      } catch (error) {
        setTimeout(() => {
          this.inputMsg = msg
        }, 100)
        this.$message.error(`发送错误：请重试或刷新页面！[${error.message}]`)
        this.send_loading = false
        // this.received = true
      }
    },
    //发送消息事件
    SendMessage(e) {
      var msg = this.inputMsg
      var imgsrc = this.uploadimgsrc
      //imgsrc = 'https://www.digitaltrends.com/wp-content/uploads/2016/06/1024px-Bill_Cunningham_at_Fashion_Week_photographed_by_Jiyang_Chen.jpg'
      //imgsrc='https://gptapi.yilvzp.com/Upload/Default/20231119/484287553314885.jpg'
      this.SendMessageMain(
        msg,
        imgsrc,
        false,
        this.aiAssistant.messageScene ?? 1
      )
      // this.SendMessageMain(msg, imgsrc, false, 1)
    },
    //获取OpenAI账户
    toGetOpenAIAccount() {
      // this.loading = true
      this.GetOpenAIAccount({
        userId: 0,
      })
        .then((res) => {
          if (res.success) {
            this.openAIAccount = res.data
          }
          // this.loading = false
        })
        .catch((e) => {
          // this.loading = false
        })
    },
    //导出对话记录
    toExport() {
      this.$confirm('导出对话记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: this.isDark ? 'darkMessage' : '',
      })
        .then(() => {
          //debugger;
          // this.export_loading = true
          var param = {
            List: this.talkList,
          }
          this.Export(param)
            .then((res) => {
              if (res.success) {
                const timestamp = Date.now().toString().slice(0, -3)
                const filename = `对话记录${timestamp}.xlsx`

                const h = this.$createElement
                this.$msgbox({
                  title: '下载导出文件',
                  message: h(
                    'div',
                    {
                      style: 'display: flex;justify-content: center;',
                    },
                    [
                      h(
                        'el-link',
                        {
                          style: 'font-size: 16px;',
                          attrs: {
                            href: res.data,
                            download: filename,
                          },
                          props: {
                            type: 'primary',
                            icon: 'el-icon-download',
                          },
                        },
                        '点击下载'
                      ),
                    ]
                  ),
                  showCancelButton: false,
                  showConfirmButton: false,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  beforeClose: (action, instance, done) => {
                    done()
                  },
                }).then((action) => {})
              } else {
                this.$message.error(res.message)
              }
              // this.export_loading = false
            })
            .catch((e) => {
              // this.export_loading = false
            })
        })
        .catch(() => {
          // 用户点击了取消按钮
        })
    },
    //清理对话
    clearList() {
      this.$confirm('清理所有对话记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: this.isDark ? 'darkMessage' : '',
      })
        .then(() => {
          this.talkList = []
          this.SyncChatHistory({
            aiAssistantId: this.aiAssistantId,
          })
        })
        .catch(() => {
          // 用户点击了取消按钮
        })
    },
    // 上传图片成功回调
    uploadImgSuc(response, file, fileList) {
      console.log('Image uploaded successfully:', response)
      // this.imgffo = true
      this.uploadimgsrc = response.data
      // console.log('>>>>>>>>>>this.imgffo:' + this.imgffo)
      console.log('>>>>>>>>>>this.uploadimgsrc:' + response.data)
      var text = `<img data-src="${this.uploadimgsrc}" />`
      const msgObj = {
        date: utils.getNowDate(),
        text: { text: text },
        rawText: this.uploadimgsrc,
        isimg: true,
        mine: true,
        name: this.user.userName,
        img: this.user.avatarFileUrl || this.defaultImgUrl,
        conversationId: 0,
        role: 'user',
        isSucc: true,
        textContent: text,
      }

      this.talkList.push(msgObj)
      this.toSyncChatHistory()
    },
    // 退出登录
    logOut() {
      localStorage.removeItem(this.sessionKey)
      this.changeIsAuth(false)
      this.closeAllShowingMsg()
      this.$router.push('/login')
    },
    // 收起聊天
    goBack() {
      this.$emit('goMiddle')
    },
  },
}
</script>

<style scoped lang="less">
.chatBox {
  width: 100%;
  // height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  .chatBody {
    margin-top: 30px;
    flex: 1;
    overflow-y: auto;
    .messages {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .messageItem {
        max-width: 75%;
        margin-bottom: 20px;
        // display: flex;
        // flex-wrap: nowrap;
        .messageUser {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          .avatar {
            margin-bottom: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            .avatarImg {
              // img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
              margin-right: 20px;
              background-repeat: no-repeat;
              background-position: center center;
              background-size: cover;
            }
          }
          .info {
            h5 {
              font-size: 14px;
              color: #0c0c0d;
              font-weight: 600;
              line-height: 1.3;
              margin-bottom: 0;
            }
            .time {
              font-size: 11px;
              font-weight: 500;
              color: #aaa;
              margin-bottom: 8px;
              display: inline-block;
            }
          }
        }
        .messageWrap {
          padding: 12px;
          border-radius: 10px;
          position: relative;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
          font-size: 14px;
          color: #666;
          font-weight: 400;
          letter-spacing: 0.3px;
          line-height: 26px;
          background-color: #fff;
          display: inline-block;
          max-width: 100%;

          .messageImg {
            width: 100%;
            max-width: 250px;
            min-width: 50px;
          }
          .msgText {
            word-break: break-all;
            cursor: pointer;
          }
          // ::v-deep li::marker {
          //   color: red;
          //   // box-sizing: border-box;
          //   // padding: 10px;
          //   // margin: 0;
          //   // display: inline-block;
          // }
          // ::v-deep li {
          //   list-style-type: none; /* 移除默认列表样式 */
          // }
          // ::v-deep li::before {
          //   content: counter(section) ". "; /* 使用计数器添加序号 */
          //   counter-increment: section; /* 增加计数器 */
          // }
        }
        .tools {
          padding: 10px 20px;
          display: flex;
          height: 44px;
          box-sizing: border-box;
          .icon {
            width: 15px;
            cursor: pointer;
            margin-right: 15px;
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            i {
              font-size: 14px;
              color: #212529;
            }
          }
        }
      }
      .outgoingMsg {
        margin-left: auto;
        .messageUser {
          justify-content: flex-end;
        }
        .messageWrap {
          background-color: #2f80ec;
          color: #fff;
          float: right;
        }
      }
    }
    /* 针对整个滚动条 */
    &::-webkit-scrollbar {
      width: 3px; /* 滚动条的宽度 */
    }
    /* 滚动条轨道 */
    &::-webkit-scrollbar-track {
      // background: #f1f7fe; /* 滚动条轨道的背景色 */
      background: transparent;
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      // background: #f1f7fe; /* 滚动条滑块的颜色 */
      background: transparent;
      border-radius: 5px; /* 滑块边缘的圆角 */
    }
    &:hover::-webkit-scrollbar-thumb {
      background: rgb(238, 238, 238);
    }
  }

  .chatFooter {
    padding: 30px 0;
    .toolsBox {
      padding: 10px 20px;
      .toolBtn {
        padding: 0 15px 0 0;
        display: inline-block;
        margin: 0;
        i {
          font-size: 14px;
          color: #007bff;
        }
      }
    }
    .sendBox {
      border-radius: 8px;
      position: relative;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
      height: 60px;
      overflow: hidden;
      // :global(.el-textarea__inner) {
      //   width: 100%;
      //   line-height: 60px;
      //   padding: 0 20px;
      //   border: 0;
      //   background-color: transparent;
      //   font-size: 14px;
      //   overflow: visible;
      //   float: left;
      // }
      .sendInput {
        width: 90%;
        line-height: 60px;
        padding: 0 20px;
        border: 0;
        background-color: transparent;
        font-size: 14px;
        overflow: visible;
        float: left;

        &:focus {
          outline: 0;
        }
        &::placeholder {
          color: #dadbda;
        }
      }
      .sendBtn {
        width: 10%;
        float: left;
        line-height: 55px;
        vertical-align: middle;
        background-color: #2f80ec;
        height: 60px;
        display: inline-block;
        border: 0;
        color: #fff;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 0;
        border-radius: 0;
        .sendIcon {
          width: 25px;
          // height: 25px;
          // position: relative;
          // top: -2px;
        }
      }
    }
  }
  // 安全区
  .emptyBox {
    height: 50px;
  }

  // .chatHeader {
  //   display: none;
  // }
  .chatHeader {
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    width: 100%;
    .headerUser {
      display: flex;
      align-items: center;

      .userAvatar {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        margin-right: 20px;
        flex-shrink: 0;
        img {
          // width: 60px;
          // height: 60px;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .userInfo {
        h5 {
          font-size: 15px;
          color: #0c0c0d;
          font-weight: 600;
          line-height: 1.5;
          margin-top: 8px;
        }
        span {
          font-size: 14px;
          font-weight: 500;
          color: #666;
          // color: #2f80ec;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }
      }
    }
    .headerAction {
      display: none;
      // margin-top: 8px;
      // .headerBtn {
      //   background: #2f80ec;
      //   width: 40px;
      //   height: 40px;
      //   border-radius: 5px;
      //   display: inline-block;
      //   line-height: 47px;
      //   text-align: center;
      //   padding: 0;
      //   border: 0;
      //   i{
      //     font-size: 18px;
      //     color: #fff;
      //   }
      // }
    }
  }

  .bigImg {
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    .chatFooter {
      .sendBox {
        .sendInput {
          width: 80%;
        }
        .sendBtn {
          width: 20%;
        }
      }
    }
  }

  @media screen and (max-width: 990px) {
    .chatBody {
      margin-top: 20px;
      padding: 0 20px;
    }
    .chatFooter {
      padding: 0;
      .sendBox {
        border-radius: 0;
        .sendInput {
          width: 75%;
        }
        .sendBtn {
          width: 25%;
        }
      }
    }
    .chatHeader {
      // padding: 10px 20px;
      // display: flex;
      // justify-content: space-between;
      // box-shadow: 0 8px 30px rgba(0, 0, 0, .03);
      // border-radius: 10px;
      // width: 100%;
      // .headerUser {
      //   display: flex;
      //   align-items: center;

      //   .userAvatar {
      //     height: 60px;
      //     width: 60px;
      //     border-radius: 50%;
      //     margin-right: 20px;
      //     flex-shrink: 0;
      //     img {
      //       width: 60px;
      //       height: 60px;
      //       border-radius: 50%;
      //     }
      //   }
      //   .userInfo {
      //     h5 {
      //       font-size: 15px;
      //       color: #0c0c0d;
      //       font-weight: 600;
      //       line-height: 1.5;
      //       margin-top: 8px;
      //     }
      //     span {
      //       font-size: 11px;
      //       font-weight: 500;
      //       color: #28a745;
      //     }
      //   }
      // }
      .headerAction {
        margin-top: 8px;
        display: block;
        .headerBtn {
          background: #2f80ec;
          width: 40px;
          height: 40px;
          border-radius: 5px;
          display: inline-block;
          line-height: 47px;
          text-align: center;
          padding: 0;
          border: 0;
          i {
            font-size: 18px;
            color: #fff;
          }
        }
      }
    }
  }
}
.darkChatBox {
  background: #1a2236;
  .chatHeader {
    background: #293145;
    .headerUser {
      .userInfo {
        h5 {
          color: #fff;
        }
        span {
          color: #ddd;
        }
      }
    }
  }
  .chatBody {
    .messages {
      .darkMsgItem {
        .messageUser {
          .info {
            h5 {
              color: #ddd;
            }
          }
        }
        .messageWrap {
          background: #293145;
          color: #ddd;
        }
        .tools {
          .icon {
            i {
              color: #ddd;
            }
          }
        }
      }
      .outgoingMsg {
        .messageUser {
          .info {
            h5 {
              color: #ddd;
            }
          }
        }
      }
    }
    &:hover::-webkit-scrollbar-thumb {
      background: #ddd;
    }
  }
  .chatFooter {
    .toolsBox {
      .toolBtn {
        i {
          color: #ddd;
        }
      }
    }
    .sendBox {
      .sendInput {
        background: #293145;
        color: #fff;
      }
    }
  }
}
</style>
